module.exports = __webpack_public_path__ + "static/img/right-bottom.836ae6b0.svg";